import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
export default function SaveLetterModal({
  open,
  handleClose,
  onSave,
  defaultName,
  saving,
}) {
  const [name, setName] = useState('');
  useEffect(() => {
    if (open) setName(defaultName || '');
  }, [open, defaultName]);

  const submit = () => {
    if (saving) return;
    onSave(name.trim() || defaultName);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '12px', padding: '.5rem' } }}
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>Save to My Letters</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Give this cover letter a name so you can find it later. You'll find it
          under <strong>My Letters</strong> in the top menu.
        </DialogContentText>
        <TextField
          label="Letter name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          autoFocus
          fullWidth
          variant="outlined"
          inputProps={{ maxLength: 120 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} color="inherit" disabled={saving}>
          Cancel
        </Button>
        <Button
          onClick={submit}
          variant="contained"
          color="primary"
          disabled={saving}
          sx={{
            fontWeight: 'bold',
            '&:hover': { backgroundColor: 'blue', transform: 'scale(1.05)' },
          }}
        >
          {saving ? <CircularProgress size={24} color="inherit" /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
